<template>
  <section class="trs-form">
    <trs-collapse-item
      class="confirm-proposal flex-nowrap mb-3 mr-md-5"
      :visible="true"
      :id="id"
      :mode="'TRS_CONFIRM_PROPOSAL'"
      :text="getContent('TRS_CONFIRM_PROPOSAL')"
    ></trs-collapse-item>
    <trs-collapse-item
      class="edit-proposal flex-nowrap mb-3"
      :id="id"
      :mode="'TRS_EDIT_PROPOSAL'"
      :text="getContent('TRS_EDIT_PROPOSAL')"
    ></trs-collapse-item>
  </section>
</template>

<script>
import TrsCollapseItem from '@/components/quotes/trsForm/TrsCollapseItem'
import trsFormContent from '@/components/quotes/trsForm/trsFormContent'

export default {
  props: ['id'],
  name: 'TrsForm',
  components: {
    TrsCollapseItem,
  },
  methods: {
    getContent(mode) {
      return trsFormContent(this.content, mode)
    },
  },
}
</script>
